export default "__VITE_ASSET__3858eb63__"